export const CURATOR_OVERRIDE_TYPES = [
  'NOT_DUPLICATE',
  'IS_DUPLICATE',
  'NOT_IN_TOPIC',
  'IN_TOPIC',
  'QUALITY',
] as const;

export type CuratorOverrideType = (typeof CURATOR_OVERRIDE_TYPES)[number];
export type CuratorOverrideActionType = Exclude<CuratorOverrideType, 'QUALITY'>;
export type CuratorOverrideTone = 'quality' | 'topic' | 'duplicate';

export const CURATOR_OVERRIDE_LABELS: Record<CuratorOverrideType, string> = {
  QUALITY: 'Quality',
  NOT_DUPLICATE: 'Not a duplicate',
  IS_DUPLICATE: 'Mark as duplicate',
  NOT_IN_TOPIC: 'Wrong topic',
  IN_TOPIC: 'Correct topic',
};

export const CURATOR_OVERRIDE_DESCRIPTIONS: Record<CuratorOverrideActionType, string> = {
  NOT_DUPLICATE: 'Record that this article should not be treated as a duplicate.',
  IS_DUPLICATE: 'Record that this article is a duplicate of another.',
  NOT_IN_TOPIC: 'Record that this article is wrongly grouped under this topic.',
  IN_TOPIC: 'Record that this article correctly belongs to this topic.',
};

export function curatorOverrideTone(type: CuratorOverrideType): CuratorOverrideTone {
  if (type === 'QUALITY') return 'quality';
  if (type === 'NOT_IN_TOPIC' || type === 'IN_TOPIC') return 'topic';
  return 'duplicate';
}
